// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { MessageTokens } from './type';

const messageTokens: MessageTokens = {
  messageShadow: 'Shadow-3',
  messageBorderColor: 'Neutral-border-1',
  messageBackgroundColor: 'Neutral-fill-1',
  messageFontColor: 'Neutral-text-5',
  messageMarginBottom: 'Margin-24',
};

export default messageTokens;
